import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  const [orientation, setOrientation] = useState(
    typeof window !== 'undefined'
      ? window.screen?.orientation?.type ||
          (window.innerHeight > window.innerWidth ? 'portrait' : 'landscape')
      : 'portrait'
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      // Fallback for browsers that don't support screen.orientation
      setOrientation(
        window.innerHeight > window.innerWidth ? 'portrait' : 'landscape'
      );
    };

    const handleOrientation = () => {
      if (window.screen?.orientation) {
        setOrientation(window.screen.orientation.type);
      }
    };

    window.addEventListener('resize', handleResize);
    window.screen?.orientation?.addEventListener('change', handleOrientation);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.screen?.orientation?.removeEventListener(
        'change',
        handleOrientation
      );
    };
  }, []);

  return {
    width: windowSize.width,
    height: windowSize.height,
    orientation,
    isPortrait: orientation.includes('portrait'),
    isLandscape: orientation.includes('landscape'),
    // Match your Tailwind Config Breakpoints
    isMobile: windowSize.width < 768,
    isTablet: windowSize.width >= 768 && windowSize.width < 1024,
    isLaptop: windowSize.width >= 1024 && windowSize.width < 1280,
    isDesktop: windowSize.width >= 1280,
    // Helper to detect "Tablet held sideways"
    isTabletLandscape:
      windowSize.width >= 768 &&
      windowSize.width <= 1180 &&
      window.innerHeight < window.innerWidth,
  };
};
